import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuthHeader } from '../services/tokenService';
import { Sparkles, Wallet, TrendingUp } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Carte de pilotage budget pour l'Assistant IA Devis (espace COOPER'S) :
 * nombre d'analyses IA consommées ce mois-ci + crédits restants.
 */
export default function AssistantIAUsageCard() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const now = new Date();
        const from = new Date(now.getFullYear(), now.getMonth(), 1)
          .toISOString().slice(0, 10);
        const res = await axios.get(
          `${API}/api/credits/me/usage?date_from=${from}`,
          { headers: getAuthHeader() }
        );
        setData(res.data);
      } catch {
        setData(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const ia = (data?.top_actions || []).find((a) => a.code === 'assistant_ia_devis');
  const analyses = ia?.nb_operations || 0;
  const consommes = ia?.credits_consommes || 0;
  const solde = data?.solde?.total ?? 0;
  const moisLabel = new Date().toLocaleDateString('fr-FR', { month: 'long', year: 'numeric' });

  if (loading) return null;

  return (
    <div
      className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-4"
      data-testid="assistant-ia-usage-card"
    >
      <div className="rounded-xl border border-violet-200 bg-violet-50 p-4 flex items-center gap-3">
        <div className="p-2 rounded-lg bg-violet-100">
          <Sparkles className="h-5 w-5 text-violet-600" />
        </div>
        <div>
          <p className="text-xs text-violet-700 capitalize">Analyses IA — {moisLabel}</p>
          <p className="text-2xl font-bold text-violet-900" data-testid="ia-analyses-count">{analyses}</p>
        </div>
      </div>
      <div className="rounded-xl border border-slate-200 bg-slate-50 p-4 flex items-center gap-3">
        <div className="p-2 rounded-lg bg-slate-100">
          <TrendingUp className="h-5 w-5 text-slate-600" />
        </div>
        <div>
          <p className="text-xs text-slate-600">Crédits IA consommés ce mois</p>
          <p className="text-2xl font-bold text-slate-900">{consommes}</p>
        </div>
      </div>
      <div className="rounded-xl border border-emerald-200 bg-emerald-50 p-4 flex items-center gap-3">
        <div className="p-2 rounded-lg bg-emerald-100">
          <Wallet className="h-5 w-5 text-emerald-600" />
        </div>
        <div>
          <p className="text-xs text-emerald-700">Crédits restants</p>
          <p className="text-2xl font-bold text-emerald-900" data-testid="ia-credits-restants">{solde}</p>
        </div>
      </div>
    </div>
  );
}
